export default __webpack_public_path__ + "static/media/aoni-logo.97321162.svg";